import React from "react";
import { useNavigate } from "react-router-dom";
import { models } from "../types/modelsDatabase";

export const Home = () => {
	const navigate = useNavigate();
	return (
		<>
			<div className="relative">
				<div className="overflow-y-auto relative h-full flex gap-4 flex-wrap">
					{models.map((model, index) => (
						<div
							key={`${index}-models`}
							onClick={() => {
								navigate(`/${model.id}`);
							}}
						>
							<img src={model.model.poster} alt="poster" />
							<p>{index} modelo</p>
						</div>
					))}
				</div>
			</div>
		</>
	);
};
